export default "/assets/images/mila-feed-15.97e6bd9e11f39ede.mp4";